export default {
      id: "ic_nav_gauche-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic_nav_gauche-usage",
      toString: function () {
        return this.url;
      }
    }